import { Injectable } from '@angular/core';
import { MsgBoxService } from '../msg-boxes/msg-box.service';
import { AppConfig } from '../app.config';
import { ISoundPlayer, SoundTrack } from '../aro/components/soundPlayer/iSoundPlayer'
import * as pako from 'pako';
import {
  SignalR, SignalRConnection, IConnectionOptions,
  BroadcastEventListener
} from 'ng2-signalr';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { SoundPlayerWindowComponent } from '../aro/components/soundPlayer/soundPlayerWindow.component'
import BSON from 'bson';
@Injectable({
  providedIn: 'root'
})

export class SoundMsgMngrService {
  private SoundPlayerInstance: ISoundPlayer;
  private _connection: SignalRConnection;
  private _unsubscribeAll: Subject<any>;
  private serverDisconnect$: BroadcastEventListener<string>;
  private serverDataMessages$: BroadcastEventListener<string>;
  private Address: string = "";
  private Token: string = "";
  public SensorID: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private bsonInstance = new BSON();
  // soundplayerwindow stuff
  private dialogRef: MatDialogRef<any>;
  private sensorName: string;
  constructor(private msgBoxSrv: MsgBoxService, private _signalR: SignalR, private dialog: MatDialog) {
  }

  openSoundPlayerWindow(id: number, sensorName: string) {
    let sensorComp: SoundPlayerWindowComponent;
    this.sensorName = sensorName;
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN)
      if ((this.dialogRef.componentInstance as SoundPlayerWindowComponent).sensorId == id)
        (this.dialogRef.componentInstance as SoundPlayerWindowComponent).dialogRaise();
      else {
        (this.dialogRef.componentInstance as SoundPlayerWindowComponent).sensorId = id;
        this.SensorID.next(id);
      }
    else {
      this.dialogRef = this.dialog.open(SoundPlayerWindowComponent, SoundPlayerWindowComponent.createDialogConfig(200));
      sensorComp = this.dialogRef.componentInstance as SoundPlayerWindowComponent;
      // sensorComp.setSensorId(id);
      this.SensorID.next(id);
      (this.dialogRef.componentInstance as SoundPlayerWindowComponent).sensorId = id;
      sensorComp.dialogRaise();
    }
  }

  public setPlayerInstance(player: ISoundPlayer): void {
    this.SoundPlayerInstance = player
  }

  setAdress(str: string) {
    this.Address = str;
  }

  connect(playFrom: number = 0): void {
    if (this.Address == "")
      this.Address = AppConfig.settings.soundAddress.address;

    if(this.Address.startsWith('assets')){
      this.startAssetsBsonFetchLoop();
      return;
    }
    var sigrCfg: IConnectionOptions = {
      url: this.Address,
      qs: {
        sensorId: this.SensorID.value,
        sensorName: this.sensorName,
        playbackTime: playFrom
      },
      hubName: "AcousticHub"
    }

    this._signalR.connect(sigrCfg).then((connection) => {
      this._connection = connection as SignalRConnection;
      // enable connect flag
      connection.start().then((c) => {
        this.serverDisconnect$ = this._connection.listenFor('disconnect') as BroadcastEventListener<string>;
        this.serverDisconnect$.subscribe(() => {
          this.disconnect();
          this.msgBoxSrv.showWarnMsg("Disconnected From Sound Service...");
        });

        // this.serverDataMessages$ = connection.listenFor('receiveMessage') as BroadcastEventListener<string>;
        this.serverDataMessages$ = this._connection.listenFor('receiveMessage') as BroadcastEventListener<string>;
        this.serverDataMessages$.subscribe((payload) => {
          try {
            const uint8Array = this.toUnit8Array(payload);
            const buffer = Buffer.from(uint8Array);

            const msgObj = this.bsonInstance.deserialize(buffer);
            this.processAudioPayload(msgObj, false);
          }
          catch(err){
            console.error(`BSON parse from signalR failed`, err, payload)
          }
          // const buffer = new Uint8Array(arrayBuffer);

          });
      }).catch((error: any) => {
        console.error(error);
        // disable connect flag
        this.msgBoxSrv.showErrorMsg("ERROR: Sound Service connection failed. ");
      });
    },
      (err) => {
        this.msgBoxSrv.showErrorMsg("ERROR: Sound Service connection failed. ");
      });
  }

  toUnit8Array(payload: any) {
    if(typeof payload == 'string'){
      const cleanBase64 = payload.includes(',') ? payload.split(',')[1]: payload;
      return this.base64ToBuffer(cleanBase64);
    }
    if(Array.isArray(payload)){
      return new Uint8Array(payload);
    }

    throw new Error('Unsupported SignalR Bson payload Format');
  }

  disconnect(): void {
    if (this._connection) {
      this._connection.stopListening(this.serverDisconnect$);
      this._connection.stopListening(this.serverDataMessages$);
      this._connection.stop();
    }
    if(this.Address.startsWith('assets')){
      this.stopAssetsBsonFetchLoop();
    }
  }

  subscribeMe(soundPlayer: ISoundPlayer, PlaybackSec: number = 0): boolean {
    this.disconnect();
    // save the sound player instance...
    this.SoundPlayerInstance = soundPlayer;
    // attempting to connect...
    this.connect(PlaybackSec);
    return true;
  }

  public readBsonFileBinaryParsing(fileName: string = 'parse-test.bson', playImmediatly: boolean = true){
    const assetPath = `assets/acoustic-sensors/bson-files/${fileName}`;
    console.log(`Testing offline: Loadinf local BSON asset from ${assetPath}`);

    fetch(assetPath)
      .then(response => {
        if ((!response.ok)){
          clearInterval(this.bsonLoopIntervalId);
          throw new Error(`HTTP error! status: ${response.status}. Ensure file is in assets/`);
        }
        return response.arrayBuffer();
      })
      .then(arrayBuffer => {
        const buffer = Buffer.from(arrayBuffer);
        const msgObj = this.bsonInstance.deserialize(buffer);

        this.processAudioPayload(msgObj, playImmediatly);
      })
  }

  processAudioPayload(msgObj: any, playImmediately: boolean = true) {
    const audioStartTime = msgObj.audioStartTime ?? msgObj.audioStartDataTime;
    if(AppConfig.settings.videoAddress.videoPlayerInfo.enableDebugLogging){
      console.log(`Decoding FLAC audio, start time: ${audioStartTime}, sensorName ${msgObj.sensorName}`);
    }
    const flacUint8: Uint8Array = msgObj.audioData.buffer;
    const flacBuffer = flacUint8.buffer.slice(flacUint8.byteOffset, flacUint8.byteOffset + flacUint8.byteLength);

    const soundTrack: SoundTrack = new SoundTrack();
    const source = this.SoundPlayerInstance.Player.createBufferSource();

    this.SoundPlayerInstance.Player.decodeAudioData(flacBuffer)
      .then((audioBuffer) => {
        console.log(`Decode successfully, duration: ${audioBuffer.duration}`);
        source.buffer = audioBuffer;
        soundTrack.Source = source;
        soundTrack.Time = new Date(audioStartTime);
        soundTrack.Title = msgObj.sensorName;
        if(playImmediately){
          this.SoundPlayerInstance.setSoundTrack(soundTrack);
        }
        else{
          this.SoundPlayerInstance.addToQueue(soundTrack);
        }
      })
      .catch(err => console.error('decodeAudioData failed:', err));
  }

  private bsonLoopIntervalId: any = null;

  public stopAssetsBsonFetchLoop(): void {
    if(this.bsonLoopIntervalId){
      clearInterval(this.bsonLoopIntervalId);
      this.bsonLoopIntervalId = null;
    }
  }

  public async startAssetsBsonFetchLoop(intervalMs: number = 750): Promise<void> {
    if (this.bsonLoopIntervalId){
      return;
    }
    var sensorFolder = this.sensorName;

    let fileNames = await this.loadSensorManifest(sensorFolder);
    if (!fileNames || fileNames.length === 0){
      console.error(`No manifest entries found for sensor folder: ${sensorFolder}, switching to testFolder`);
      sensorFolder = 'test';
      fileNames = await this.loadSensorManifest(sensorFolder);
      if (!fileNames || fileNames.length === 0){
        console.error(`No manifest entries found for sensor test folder`);
        return;
      }
    }

    let index = 0; 
    this.bsonLoopIntervalId = setInterval(() => {
      this.readBsonFileBinaryParsing(`${sensorFolder}/${fileNames[index]}`, false);
      const nextIndex = index + 1;
      index = nextIndex == fileNames.length ? 0 : nextIndex;
    })
  }

  
  private async loadSensorManifest(sensorFolder:string): Promise<string[]>{
    const manifestPath = `assets/acoustic-sensors/bson-files/${sensorFolder}/manifest.json`;
    const response = await fetch(manifestPath);
    if(!response.ok){
      console.error(`Manifest not found at ${manifestPath}. Run node scripts/generate-bson-manifest.js`);
      return [];
    }
    const manifest = await response.json();
    return manifest.files as string[];
  }

  private base64ToBuffer(compressedData: string): Uint8Array {
    // Decode base64 to Uint8Array
    const binaryString = atob(compressedData);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  private decompressGzip(compressedData: string): Int16Array {
    // Decode base64 to Uint8Array
    const binaryString = atob(compressedData);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    // Decompress using pako
    const decompressed = pako.inflate(bytes);
    return new Int16Array(decompressed.buffer); // Convert to Int16Array
  }

  private pcmToWav(pcmData: Int16Array, sampleRate: number, numChannels: number, bitRate: number): Blob {
    const buffer = new ArrayBuffer(44 + pcmData.length * 2);
    const view = new DataView(buffer);
    // Write WAV header
    this.writeString(view, 0, 'RIFF'); //riff
    view.setUint32(4, 36 + pcmData.length * 2, true); // full sound size
    this.writeString(view, 8, 'WAVE'); // file type header wave
    this.writeString(view, 12, 'fmt '); // format chunk marker
    view.setUint32(16, 16, true); // length of format data
    view.setUint16(20, 1, true); // tyep of format 1 = pcm
    view.setUint16(22, numChannels, true); //number of channel should be 8 according to elbit
    view.setUint32(24, sampleRate, true); //sample rate should be 8000 according to elbit
    view.setUint32(28, sampleRate * numChannels * 2, true);
    view.setUint16(32, numChannels * 2, true);
    view.setUint16(34, bitRate, true); // bit rate should be 32
    this.writeString(view, 36, 'data');
    view.setUint32(40, pcmData.length * 2, true);
    // Write PCM samples
    for (let i = 0; i < pcmData.length; i++) {
      view.setInt16(44 + i * 2, pcmData[i], true);
    }
    return new Blob([buffer], { type: 'audio/wav' });
  }

  private writeString(view: DataView, offset: number, str: string) {
    for (let i = 0; i < str.length; i++) {
      view.setUint8(offset + i, str.charCodeAt(i));
    }
  }
}
